import * as React from 'react';
import { IPortalSectionProps } from 'models/portal/page/portalpagesection';
import { IPortalPageSectionItem } from 'models/portal/page/portalpagesectionitem';
import { PortalPageSectionItemRenderer } from 'components/PortalPage/SectionItems/SectionItemRenderer';
import { ISectionTextElement } from 'models/common/sectiontextelement';
import { SectionTitle } from 'components';
require('./style.css');

interface IProps extends IPortalSectionProps {
	t?: (key: string, options?: any) => string;
}

class ViewType2 extends React.Component<IProps, any> {
	constructor(props) {
		super(props);
	}

	public render() {
		const { items } = this.props.section;
		if (!items.length) {
			return null;
		}
		const title =
			(items[0].elements && items[0].elements.length ? (items[0].elements[0] as ISectionTextElement).text : '') || '';

		const renderedItems = items.slice(1).map((item: IPortalPageSectionItem, index: number) => {
			const isLastItemInRow: boolean = index === items.length - 1 || (index + 1) % 3 === 0;
			return (
				<PortalPageSectionItemRenderer
					key={'portalpagesectionrenderer_' + (item ? item.type : 'empty') + '_' + index}
					portalPageSectionItem={item}
					isLastItemInRow={isLastItemInRow}
				/>
			);
		});

		return (
			<div className="portalPageSectionType2 portalContentWrapper container-fluid landingContainer list-with-title">
				<SectionTitle variant="white">{title}</SectionTitle>
				<div className="items">{renderedItems}</div>
			</div>
		);
	}
}

export { ViewType2 };
